import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Button,
  CircularProgress,
  IconButton,
  Tab,
  Tabs,
  Typography,
  Box,
  Paper,
} from "@mui/material";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DateRangeFilter from "../../components/Common/DateRangeFilter";
import PredictionParts from "./Components/PredictionParts";
import SidePanelHeader from "../../components/Common/SidePanelHeader";
import ProductionChart from "./Components/ProductionChart";
import QualityTable from "./Components/QualityTable";
import RecommendationPanel from "../../components/Common/RecommendationPanel";
import { customDateConvert } from "../../components/Common/Utils/Utils";
import useApi from "../../service/api.service";
import CustomSkeleton from "../../components/Common/CustomSkeleton";
import CustomHead from "../../components/Common/CustomHead";

function Quality() {
  const [isMaximized, setIsMaximized] = useState(false);
  const [filterParts, setFilterParts] = useState("All");
  const [pieData, setPieData] = useState(null);
  const [loading1, setLoading1] = useState(false);
  const API = useApi();

  const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "20px",
    padding: "10px",
    borderRadius: "10px",
    fontWeight: 500,
    color: "#404040",
    boxShadow: "none",
    border: "1px solid #E4E4E4",
  };
  const filterContainerStyle = {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  };
  const allTabStyle = {
    fontSize: "12px",
    border: "1px solid #D4D4D4",
    borderRadius: "25px",
    marginRight: "10px",
  };
  const textStyle = {
    fontSize: "12px",
    marginRight: "10px",
    fontWeight: "500",
  };
  const chartPaperStyle = {
    flex: 1,
    borderRadius: "20px",
    height: "250px",
    // boxShadow: "0px 3px 6px #0000001F",
    boxShadow: "none",
    border: "1px solid #E4E4E4",
  };
  const layoutBoxStyle = {
    width: "97%",
    marginTop: "20px",
    mx: "auto",
    display: "flex",
    gap: "20px",
  };

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
      enabled: false,
      status: false,
    },
  ]);

  const oneDay = 24 * 60 * 60 * 1000;
  const oneWeek = 7 * oneDay;
  const defaultStartDate = new Date(Date.now() - oneWeek);
  const defaultEndDate = new Date(Date.now() - oneDay);

  const [finalDate, setFinalDate] = useState({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  const [toggleDateFilter, setToggleDateFilter] = useState(false);
  const [value, setValue] = useState(1);

  const fetchData = async () => {
    const customParams = {
      startTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
    };

    try {
      setLoading1(true);
      const response = await API.getPartsCount(customParams);
      setLoading1(false);
      setPieData(response.data[0]);
    } catch (error) {
      setLoading1(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    // console.log(pieData);
  }, [finalDate]);

  return (
    <Box sx={{ height: `calc(100vh - 100px)`, overflow: "auto", mt:"20px" }}>
      <CustomHead
        title={"Quality Prediction"}
        dateRange={dateRange}
        setDateRange={setDateRange}
        value={value}
        setValue={setValue}
        finalDate={finalDate}
        setFinalDate={setFinalDate}
      />
      <Box sx={layoutBoxStyle}>
        <Paper sx={chartPaperStyle}>
          {loading1 ? (
            <CustomSkeleton height="250px" />
          ) : (
            <ProductionChart
              totalParts={pieData?.Total_Parts}
              goodPrediction={pieData?.Good_Parts}
              suspiciousPrediction={pieData?.Suspicious_Parts}
              actualGood={pieData?.Actual_Good_Parts}
              actualScrap={pieData?.Actual_Scrap_Parts}
            />
          )}
        </Paper>
        <Paper sx={{ ...chartPaperStyle, overflow: "auto" }}>
          <RecommendationPanel type="company" id="" />
        </Paper>
        <Paper sx={{ ...chartPaperStyle, overflow: "auto" }}>
          <SidePanelHeader type="company" id="" page="QualityHome" finalDate={finalDate} />
        </Paper>
      </Box>
      <Paper
        sx={{
          width: "97%",
          mx: "auto",
          mt: 2,
          borderRadius: "25px",
          // boxShadow: "0px 3px 6px #0000001F",
          boxShadow: "none",
          border: "1px solid #E4E4E4",
          maxHeight: `calc(100vh - 115px)`,
          overflow: "auto",
          mb: 1,
        }}
      >
        <QualityTable finalDate={finalDate} dateRange={dateRange} />
      </Paper>
    </Box>
  );
}

export default Quality;
